import React, { useState, useEffect } from "react"
import OTPmodal from "./OTPModal"
import Loader from "../../components/Loader"
import NewBusinessIcon from "../../images/business/new-business.svg"
import BusinessTitleCard from "./BusinessCardTitle"
import ProceedButton from "./ProceedButton"

const Verify = (props) => {
  const { state } = props.location

  const [nameEnquiry, setNameEnquiry] = useState({
    AccountNumber: "",
    DIC: "090325",
  })

  const [message, setMessage] = useState("")
  const [accountData, setAccountData] = useState("")
  const [isSearching, setIsSearching] = useState(true)
  const [isLoading, setIsLoading] = useState(false)
  const [btnlaoding, setBtnloading] = useState(false)

  const [popup, setPopup] = useState(false)

  const debouncedSearchTerm = useDebounce(nameEnquiry.AccountNumber, 500)

  const hidePopup = () => {
    setPopup(false)
  }

  const reg = /.{1,9}/

  // Request OTP function
  function requestOtp(param) {
    if (accountData !== "") {
      setBtnloading(true)
      fetch(`${process.env.GATSBY_SPARKLE_LOCAL_BASE_URL}/api/v1/otp/send`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          nuban: param,
        }),
      })
        .then((r) => r.json())
        .then((r) => {
          setPopup(true)
          setBtnloading(false)
        })
        .catch((error) => {
          console.error(error)
        })
    }
  }

  const handleAccountChange = (evt) => {
    const value = evt.target.value
    setNameEnquiry({
      ...nameEnquiry,
      [evt.target.name]: value,
    })
  }

  // Effect for API call
  useEffect(
    () => {
      if (debouncedSearchTerm && nameEnquiry.AccountNumber.length > 9) {
        setIsLoading(true)
        fetch(
          `${process.env.GATSBY_SPARKLE_LOCAL_BASE_URL}/api/v1/accounts/fetch-account-name/${nameEnquiry.AccountNumber}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          }
        )
          .then((r) => r.json())
          .then((r) => {
            if (r.status === "success") {
              setAccountData(r.data)
              setMessage("")
              setIsSearching(true)
              setIsLoading(false)
            } else {
              setAccountData("")
              setMessage(r.message)
              setIsSearching(false)
              setIsLoading(false)
            }
          })
          .catch((error) => {
            console.error(error)
            return []
          })
      } else {
        setAccountData("")
        setIsSearching(false)
      }
    },
    [debouncedSearchTerm] // Only call effect if debounced search term changes
  )

  return (
    <>
      <div className="row justify-content-center">
        <div className="col-lg-8">
          <BusinessTitleCard
            icon={NewBusinessIcon}
            title={state.service}
            subtitle="Officially register your business, get CAC and a tax identification number."
          />

          <div className="business-suport-card my-lg-5 waitlist__form p-lg-5 p-4">
            <div className="form-row justify-content-center">
              <div className="form-group col-12">
                <label htmlFor="account_number">Sparkle Account Number</label>

                <input
                  type="tel"
                  className="form-control"
                  id="AccountNumber"
                  name="AccountNumber"
                  onChange={handleAccountChange}
                  value={nameEnquiry.AccountNumber}
                  onKeyPress={(event) => {
                    if (!/[0-9]/.test(event.key)) {
                      event.preventDefault()
                    }
                  }}
                  maxLength="10"
                />

                <p className="sparkle-green mt-3">
                  <b>
                    {accountData !== "" &&
                      accountData.replace(reg, (m) => "X".repeat(m.length))}
                  </b>
                </p>

                <span className="text-danger">{message}</span>
              </div>
            </div>

            <OTPmodal
              show={popup}
              closePopup={hidePopup}
              requestNewOtp={() => requestOtp(nameEnquiry.AccountNumber)}
              account={nameEnquiry.AccountNumber}
              path={state.path}
            />

            {isLoading && <Loader width="50" color="#46b839" />}
            <ProceedButton
              text="Proceed"
              handleClick={() => requestOtp(nameEnquiry.AccountNumber)}
              disable={!isSearching}
              type="button"
              btnloading={btnlaoding}
            />

            {/* <div className="row py-5">
              <div className="col-lg-4 offset-lg-8">
                <button
                  className="btn sparkle--button__green px-5 mt-4 btn-block"
                  onClick={() => requestOtp(nameEnquiry.AccountNumber)}
                  disabled={!isSearching}
                >
                  Proceed
                </button>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </>
  )
}

export default Verify

// Hook
function useDebounce(value, delay) {
  // State and setters for debounced value
  const [debouncedValue, setDebouncedValue] = useState(value)
  useEffect(
    () => {
      // Update debounced value after delay
      const handler = setTimeout(() => {
        setDebouncedValue(value)
      }, delay)
      // Cancel the timeout if value changes (also on delay change or unmount)
      // This is how we prevent debounced value from updating if value is changed ...
      // .. within the delay period. Timeout gets cleared and restarted.
      return () => {
        clearTimeout(handler)
      }
    },
    [value, delay] // Only re-call effect if value or delay changes
  )
  return debouncedValue
}
